import {Flex, IconButton, Text} from '@chakra-ui/react';
import {IconDownload} from '@tabler/icons';
import mixpanel from 'mixpanel-browser';

interface KeyDocumentRowProps {
  documentName: string;
  url: string;
}

export const KeyDocumentRow: React.FC<KeyDocumentRowProps> = ({
  documentName,
  url,
}: KeyDocumentRowProps) => {
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      borderColor="gray.500"
      borderTop="1px solid"
      px={{base: '0', md: '20px'}}
    >
      <Text my="16px">{documentName}</Text>
      <a
        href={url}
        onClick={() => {
          mixpanel.track('Document download click', {document: documentName});
        }}
      >
        <IconButton
          as={IconDownload}
          height="24px"
          width="24px"
          aria-label="Download document"
          variant="link"
          color="primary"
          cursor="pointer"
        />
      </a>
    </Flex>
  );
};
